
export type LeadStatus =
  | 'neu'
  | 'kontaktiert'
  | 'gesprochen'
  | 'termin_fixiert'
  | 'abgeschlossen'
  | 'kein_interesse';

export interface Lead {
  id: string;
  assigned_user_id: string | null;
  facebook_lead_id: string;
  name: string;
  email: string;
  phone: string;
  company?: string;
  website?: string;
  source?: string;
  created_at: string;
  status: LeadStatus;
  status_changed_at: string;
  notes: string;
  stage_id?: string | null;
  archived?: boolean;
  custom_fields?: Record<string, string>;
  meta_data: {
    campaign?: string;
    ad_name?: string;
    company?: string;
    owner_status?: string;
    [key: string]: any;
  };
}

export interface LeadActivity {
  id: string;
  lead_id: string;
  user_id: string;
  activity_type: string;
  old_value?: string;
  new_value?: string;
  created_at: string;
  user_name?: string;
}

export const STATUS_CONFIG: Record<LeadStatus, { label: string; color: string; bg: string }> = {
  neu: { label: 'Neu', color: 'text-gray-600', bg: 'bg-gray-100' },
  kontaktiert: { label: 'Kontaktiert', color: 'text-orange-600', bg: 'bg-orange-100' },
  gesprochen: { label: 'Gesprochen', color: 'text-yellow-600', bg: 'bg-yellow-100' },
  termin_fixiert: { label: 'Termin fixiert', color: 'text-purple-600', bg: 'bg-purple-100' },
  abgeschlossen: { label: 'Abgeschlossen', color: 'text-green-600', bg: 'bg-green-100' },
  kein_interesse: { label: 'Kein Interesse', color: 'text-red-600', bg: 'bg-red-100' },
};

export type PriorityTagType =
  | 'callback'
  | 'urgent_callback'
  | 'hot_lead'
  | 'warm_lead'
  | 'cold_lead'
  | 'termin'
  | 'followup'
  | 'awaiting_response'
  | 'unreachable';

export const PRIORITY_TAG_CONFIG: Record<PriorityTagType, {
  label: string;
  color: string;
  bg: string;
}> = {
  callback: { label: 'Rückruf', color: 'text-yellow-700', bg: 'bg-yellow-100' },
  urgent_callback: { label: 'Dring. Rückruf', color: 'text-red-700', bg: 'bg-red-100' },
  hot_lead: { label: 'Heißer Lead', color: 'text-red-600', bg: 'bg-red-100' },
  warm_lead: { label: 'Warmer Lead', color: 'text-yellow-600', bg: 'bg-yellow-100' },
  cold_lead: { label: 'Kalter Lead', color: 'text-blue-600', bg: 'bg-blue-100' },
  termin: { label: 'Termin', color: 'text-green-700', bg: 'bg-green-100' },
  followup: { label: 'Follow-up', color: 'text-purple-600', bg: 'bg-purple-100' },
  awaiting_response: { label: 'Warten a. Antwort', color: 'text-orange-700', bg: 'bg-orange-100' },
  unreachable: { label: 'Nicht erreichbar', color: 'text-gray-500', bg: 'bg-gray-50' },
};
